// Empresa dueña (vendedora) frente a sus promotores (fase 4). Contrato: docs/CONTRATO-API-FASE4.md.
// Token de empresa; un staff recibe 403 (y no ve estas pantallas).
import { empresaFetch } from './empresaApi';
import { query } from '../utils/query';

// status: all | pending | accepted | rejected | revoked
export const listEmpresaPromoterLinks = (status = 'all') =>
  empresaFetch(`/api/empresa/promoter-links${query({ status })}`);

// action: accept | reject | revoke. `note` (≤500) se muestra al promotor en reject/revoke.
export const respondPromoterLink = (id, action, note) =>
  empresaFetch(`/api/empresa/promoter-links/${encodeURIComponent(id)}/${action}`, {
    method: 'POST',
    body: note ? { note } : {},
  });

// params: { from, to, status, source, promoterId, page, limit }
export const listEmpresaPromoterSales = (params) =>
  empresaFetch(`/api/empresa/promoter-sales${query(params)}`);

// params: { status, promoterId, from, to, page, limit }
export const listEmpresaPromoterCuts = (params) =>
  empresaFetch(`/api/empresa/promoter-cuts${query(params)}`);

export const getEmpresaPromoterCut = (id) =>
  empresaFetch(`/api/empresa/promoter-cuts/${encodeURIComponent(id)}`);

// body: { paidDate?: 'YYYY-MM-DD', note?: ≤500 }
export const markPromoterCutPaid = (id, body) =>
  empresaFetch(`/api/empresa/promoter-cuts/${encodeURIComponent(id)}/mark-paid`, {
    method: 'POST',
    body,
  });
